import * as core from '../../../../../../../core'

import { query } from './ideas-by-los.query'

export const RESOURCE = {
  payload: {
    alias: 'ideas.los.donut',
    description: 'Donut chart to display ideas by Lane of Support',
    name: 'Ideas by LOS',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
